import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchAreas } from 'Redux/Admin/HabitManager/Areas/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { IArea } from 'Redux/Admin/HabitManager/Areas/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const columns: TableColumnsType<IArea> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/habit-manager/areas/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 280,
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    width: 280,
  },
  {
    title: 'Default Order',
    dataIndex: 'default_order',
    key: 'default_order',
    width: 280,
  }
];

const Areas = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const user = params.get('user');
  const searchValue = params.get('search');
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchAreas);

  useEffect(() => {
    dispatch(fetchAreas({ user, search: searchValue, offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [user, searchValue, pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    {
      type: 'search',
      paramName: 'search',
      label: 'Search',
      placeholder: 'Search...'
    },
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<IArea>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/habit-manager/areas/new`}
      filters={filterConfigs}
    />
  );
}

export default Areas;
